import { ElementsTable } from '../../../types';
import { ReactComponent as Mesh } from '../../../icons/Mesh.svg';

export const TYPE_MAPPER: ElementsTable = {
  cache: Mesh,
  encapsulate: Mesh,
  extend: Mesh,
  federation: Mesh,
  filterSchema: Mesh,
  mock: Mesh,
  namingConvention: Mesh,
  prefix: Mesh,
  rename: Mesh,
  resolversComposition: Mesh,
  snapshot: Mesh,
};
